/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConfigureRulesStackListQueryVariables = {|
  greenMachineSessionID: string
|};
export type ConfigureRulesStackListQueryResponse = {|
  +stackRulesForGreenMachineSession: ?$ReadOnlyArray<?{|
    +id: string,
    +newPlayers: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +slatePlayer: {|
            +player: {|
              +name: string
            |}
          |},
          +greenmachinesessionstackruleplayerSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +locked: boolean
              |}
            |}>
          |},
        |}
      |}>
    |},
    +stackRule: {|
      +displayName: string
    |},
    +numLineups: number,
    +stackValue: number,
    +required: boolean,
    +gcStaffStack: boolean,
  |}>
|};
export type ConfigureRulesStackListQuery = {|
  variables: ConfigureRulesStackListQueryVariables,
  response: ConfigureRulesStackListQueryResponse,
|};
*/


/*
query ConfigureRulesStackListQuery(
  $greenMachineSessionID: ID!
) {
  stackRulesForGreenMachineSession(greenMachineSessionId: $greenMachineSessionID) {
    id
    newPlayers {
      edges {
        node {
          slatePlayer {
            player {
              name
              id
            }
            id
          }
          greenmachinesessionstackruleplayerSet {
            edges {
              node {
                locked
                id
              }
            }
          }
          id
        }
      }
    }
    stackRule {
      displayName
      id
    }
    numLineups
    stackValue
    required
    gcStaffStack
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "greenMachineSessionID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "greenMachineSessionId",
    "variableName": "greenMachineSessionID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numLineups",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stackValue",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gcStaffStack",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfigureRulesStackListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GreenMachineSessionStackRuleType",
        "kind": "LinkedField",
        "name": "stackRulesForGreenMachineSession",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GreenMachineSessionPlayerTypeConnection",
            "kind": "LinkedField",
            "name": "newPlayers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GreenMachineSessionPlayerTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GreenMachineSessionPlayerType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SlatePlayerType",
                        "kind": "LinkedField",
                        "name": "slatePlayer",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PlayerType",
                            "kind": "LinkedField",
                            "name": "player",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GreenMachineSessionStackRulePlayerTypeConnection",
                        "kind": "LinkedField",
                        "name": "greenmachinesessionstackruleplayerSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GreenMachineSessionStackRulePlayerTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GreenMachineSessionStackRulePlayerType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StackRuleType",
            "kind": "LinkedField",
            "name": "stackRule",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfigureRulesStackListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GreenMachineSessionStackRuleType",
        "kind": "LinkedField",
        "name": "stackRulesForGreenMachineSession",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GreenMachineSessionPlayerTypeConnection",
            "kind": "LinkedField",
            "name": "newPlayers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GreenMachineSessionPlayerTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GreenMachineSessionPlayerType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SlatePlayerType",
                        "kind": "LinkedField",
                        "name": "slatePlayer",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PlayerType",
                            "kind": "LinkedField",
                            "name": "player",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GreenMachineSessionStackRulePlayerTypeConnection",
                        "kind": "LinkedField",
                        "name": "greenmachinesessionstackruleplayerSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GreenMachineSessionStackRulePlayerTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GreenMachineSessionStackRulePlayerType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StackRuleType",
            "kind": "LinkedField",
            "name": "stackRule",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c328e830090e690437de2a4cb77844d2",
    "id": null,
    "metadata": {},
    "name": "ConfigureRulesStackListQuery",
    "operationKind": "query",
    "text": "query ConfigureRulesStackListQuery(\n  $greenMachineSessionID: ID!\n) {\n  stackRulesForGreenMachineSession(greenMachineSessionId: $greenMachineSessionID) {\n    id\n    newPlayers {\n      edges {\n        node {\n          slatePlayer {\n            player {\n              name\n              id\n            }\n            id\n          }\n          greenmachinesessionstackruleplayerSet {\n            edges {\n              node {\n                locked\n                id\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n    stackRule {\n      displayName\n      id\n    }\n    numLineups\n    stackValue\n    required\n    gcStaffStack\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '242d3b75224757f0317b6742d8d3e449';

module.exports = node;
